import { MDSText } from '@thrivent/midwest-web';
import nextImage from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const Wrapper = styled.article`
  margin-top: 1rem;
  display: flex;
  min-height: 6rem;
  width: 100%;
  &:first-of-type {
    margin-top: 0;
  }
`;

export const TitleText = styled(MDSText.BodyHeavySm)`
  font-weight: 400;
  color: ${(p) => p.theme.midwestColors.neutralDarkHeavy};
  margin: 0;
`;

export const LinkWrapper = styled(Link)`
  display: flex;
  text-decoration: none;
  width: 100%;
  &:hover,
  &:focus {
    text-decoration: none;
    ${TitleText} {
      text-decoration: underline;
    }
  }
`;

export const ImageWrapper = styled.div`
  display: block;
  text-decoration: none;
  padding: 0;
  margin: 0;
  position: relative;
  flex-shrink: 0;
  width: 130px;
  background: ${(p) => p.theme.midwestColors.backgroundSecondary};
  border-top: 1px solid ${(p) => p.theme.midwestColors.neutralLightStrong};
  border-left: 1px solid ${(p) => p.theme.midwestColors.neutralLightStrong};
  border-bottom: 1px solid ${(p) => p.theme.midwestColors.neutralLightStrong};
`;

export const Image = styled(nextImage)`
  object-fit: cover;
  object-position: center;
`;

export const TextWrapper = styled.div`
  border: 1px solid ${(p) => p.theme.midwestColors.neutralLightStrong};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const ReadTimeText = styled(MDSText.BodyRegXs)`
  color: ${(p) => p.theme.midwestColors.neutralDarkMedium};
`;
